import { useEffect, useRef } from 'react';

export const useScrollLock = (isLocked: boolean) => {
  const scrollY = useRef(0);
  const originalStyles = useRef<{
    overflow: string;
    position: string;
    top: string;
    width: string;
    height: string;
    paddingRight: string;
  } | null>(null);

  useEffect(() => {
    if (isLocked) {
      // Store current scroll position
      scrollY.current = window.scrollY;

      // Store original styles
      originalStyles.current = {
        overflow: document.body.style.overflow,
        position: document.body.style.position,
        top: document.body.style.top,
        width: document.body.style.width,
        height: document.body.style.height,
        paddingRight: document.body.style.paddingRight,
      };

      // Calculate scrollbar width to prevent layout shift
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      // Add CSS class for additional scroll lock (only to body)
      document.body.classList.add('scroll-locked');

      // Apply scroll lock only to body (not html)
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY.current}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      return () => {
        // Remove CSS classes
        document.body.classList.remove('scroll-locked');

        // Restore original styles
        if (originalStyles.current) {
          document.body.style.overflow = originalStyles.current.overflow;
          document.body.style.position = originalStyles.current.position;
          document.body.style.top = originalStyles.current.top;
          document.body.style.width = originalStyles.current.width;
          document.body.style.height = originalStyles.current.height;
          document.body.style.paddingRight = originalStyles.current.paddingRight;
          document.body.style.left = '';
          document.body.style.right = '';
        }

        // Restore scroll position
        window.scrollTo(0, scrollY.current);
      };
    }
  }, [isLocked]);
};
